export default "__VITE_ASSET__BoQ7oJYs__"